// Men wardrobe style
import MenCasualWear from "@/assets/images/MenWardrobeStyle/men-casual.png";
import MenBusinessWear from "@/assets/images/MenWardrobeStyle/men-business.png";
import MenTraditionalWear from "@/assets/images/MenWardrobeStyle/men-traditional.png";
import MenSportsWear from "@/assets/images/MenWardrobeStyle/men-sports.png";

// Men skin tone
import MenFairSkinned from "@/assets/images/MenSkinTone/fair-skinned-men.png";
import MenBrownSkinned from "@/assets/images/MenSkinTone/brown-skinned-men.png";
import MenDarkSkinned from "@/assets/images/MenSkinTone/dark-skinned-men.png";

// Men body type
import AverageMenBody from "@/assets/images/MenBodyType/men-average-men.png";
import SlimMenBody from "@/assets/images/MenBodyType/men-slim-men.png";
import AthleticMenBody from "@/assets/images/MenBodyType/men-athletic-men.png";
import PlusSizeMenBody from "@/assets/images/MenBodyType/men-plus-size-men.png";

// Women body type
import WomenAverage from "@/assets/images/WomenBodyType/women-average.png";
import WomenAthletic from "@/assets/images/WomenBodyType/women-athletic.png";
import WomenSlim from "@/assets/images/WomenBodyType/women-slim.png";
import WomenPlusSize from "@/assets/images/WomenBodyType/women-plusSize.png";

// womenmen wardrobe style
import WomenCasualWear from "@/assets/images/WomenWarddrobeSyle/women-causal.png";
import WomenBusinessWear from "@/assets/images/WomenWarddrobeSyle/women-buisness.png";
import WomenTraditionalWear from "@/assets/images/WomenWarddrobeSyle/women-traditional.png";
import WomenSportsWear from "@/assets/images/WomenWarddrobeSyle/women-sports.png";

// women skin tone
import WomenFairSkinned from "@/assets/images/WomenSkinTone/women-fair.png";
import WomenBrownSkinned from "@/assets/images/WomenSkinTone/women-brown.png";
import WomenDarkSkinned from "@/assets/images/WomenSkinTone/women-dark.png";

// tone of video
import Casual from "@/assets/videos/toneOfVideo/casual.mp4";
import Dramatic from "@/assets/videos/toneOfVideo/dramatic.mp4";
import Humorous from "@/assets/videos/toneOfVideo/humorous.mp4";
import Professional from "@/assets/videos/toneOfVideo/professional.mp4";

import DashboardIcon from "@/assets/icons/Dashboard.svg";
import ProjectsIcon from "@/assets/icons/Projects.svg";
import CalenderIcon from "@/assets/icons/Calender.svg";
import TemplateIcon from "@/assets/icons/Template.svg";
import MessagesIcon from "@/assets/icons/Messages.svg";
import NotificationsIcon from "@/assets/icons/Notification.svg";
// import Orders from "@/pages/orders/orders";
// import Messages from "@/pages/messages/messages";
// import Calender from "@/pages/calender/calender";
// import Notifications from "@/pages/notifications/notifications";
import {
  PlanDetailsTypes,
  PreferredVideoTypesProps,
  SelectComponetOption,
  SidebarLink,
} from "@/types/types";
import WalletIcon from "@/assets/icons/PricingPlan.svg";
import InvoiceIcon from "@/assets/icons/Invoices.svg";
import SettingIcon from "@/assets/icons/Setting.svg";
import Question from "@/assets/icons/Question.svg";
// import Pricing from "@/pages/pricing/pricing";
// import Billing from "@/pages/billing/billing";
// import Help from "@/pages/help/help";
// import Setting from "@/pages/setting/setting";
// import Dashboard from "@/pages/dashboard/dashboard";

import JobsIcon from "@/assets/icons/JobsIcon.svg";

import Style1Image from "@/assets/images/videoEditingDetails/style-1.png";
import PotraitImag from "@/assets/images/videoEditingDetails/portrait.png";
import LanscapeImg from "@/assets/images/videoEditingDetails/landscape.png";
import HomeBg from "@/assets/images/videoEditingDetails/home-background.png";
import VisualBg from "@/assets/images/videoEditingDetails/visual-background.png";
import FileIcon from "@/assets/icons/File.svg";
import NotesIcon from "@/assets/icons/Notes.svg";
// import Community from "@/pages/community/community";
import CommunityIcon from "@/assets/icons/Community.svg";
import Dashboard from "@/pages/dashboard/dashboard";
import Wallet from "@/pages/Wallet/Wallet";
import Projects from "@/pages/projects/Projects";
import Jobs from "@/pages/jobs/Jobs";
import Profile from "@/pages/profile/Profile";
import Notifications from "@/pages/notifications/notifications";
import { MessagingDashboard } from "@/pages/messaging/MessagingDashboard";
// import Templates from "@/pages/templates/templates";

// export const Preffered_Video_Types: PreferredVideoTypesProps[] = [
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/actor-driven.webp",
//     id: "actor_driven",
//     title: "Actor-Driven",
//     desc: "In these videos, Actor leads by performing, recording, and editing the video.",
//   },
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/editor-driven.webp",
//     id: "editor_driven",
//     title: "Editor-Driven",
//     desc: "In these videos, Editors use stock elements and voiceovers to create the final video.",
//   },
//   {
//     img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/videographer-driven.webp",
//     id: "videoGrapher_driven",
//     title: "Videographer -Driven",
//     desc: "In these Videos, Videographers shoot products and brand videos and handle the editing.",
//   },
// ];

export const DefaultCompanyLogo =
  "https://assets.passionbits.io/platform-data/defult_company_logo.png";
export const Actor_Driven_Plans = [
  {
    videoType: "home-studio",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
    planName: "Home Studio",
    price: 3999,
    planPrice_in_text: "3999",
    description:
      "Unlock Professional marketing videos from home with our Actor-Driven Plan",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Own Home-studio environment",
      "Actor/Spokesperson",
      "Casual/Business Attire Options",
      "Home Studio (iPhone Quality)",
      "Standard Equipment",
      "Basic editing",
      "View Video Samples",
      "Choose Home - Studio",
    ],
    btnText: "Choose Home-Studio",
  },
  {
    videoType: "professional-studio",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/proffessional-studio.webp",
    planName: "Professional Studio",
    price: 17500,
    planPrice_in_text: "17,500",
    description:
      "Access Professional studio equipment for polished video production.",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Experienced Actor/Spokesperson",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "High-Quality Equipment",
      "Standard Editing",
      "View Video Samples",
      "Choose Professional - Studio",
    ],
    btnText: "Choose Professional-Studio",
  },
  {
    videoType: "multi-actor",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/multi-actor-cover.webp",
    planName: "Multi-Actor",
    planPrice_in_text: "35,000",
    price: 35000,
    description:
      "Engage with our Skit/Live Action plan featuring multiple action and live-action scenes",
    perfectFor: ["Brand Storytelling", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Professional Actor/Spokesperson",
      "Multiple Actors",
      "Studio Aesthetic",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "Enterprise grade editing",
      "View Video Samples",
      "Choose Multi-Actor",
    ],
    btnText: "Choose Multi-Actor",
  },
];

export const Editor_Driven_Plans = [
  {
    videoType: "stock-style-edits",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Stock-Style+Edits.webp",
    planName: "Stock-Style Edits",
    planPrice_in_text: "2499",
    price: 2499,
    description:
      "Get polished, professional videos with our Basic Editing services",
    perfectFor: ["Social media videos", "Marketing videos"],
    featureOverview: [
      "Unlimited stock images",
      "Brand Guidelines Alignment",
      "Basic color corrections",
      "Voice Over, Sound Effects and Music",
      "Basic editing",
      "Titles, Text captions and overlays",
    ],
    btnText: "Choose Stock - Style",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Stock-IllustrationFootage.webp",
    videoType: "stock-illustration-footage",
    planName: "Stock-Illustration/Footage",
    planPrice_in_text: "15,500",
    price: 15500,
    description:
      "Enhance and refine your videos with our Standard Editing services",
    perfectFor: ["Corporate Educational Videos", "Promotional Videos"],
    featureOverview: [
      "Illustrations and video footage.",
      "Brand Guidelines Alignment",
      "Enhanced Color Grading",
      "Audio Enhancements",
      "Standard animation effects",
      "Custom Intro & Outro",
    ],
    btnText: "Choose Stock - Illustration",
  },
  {
    videoType: "motion-graphics-3d",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Motion+Graphics3D.webp",
    planName: "Motion Graphics/3D",
    planPrice_in_text: "35,000",
    price: 35000,
    description:
      "Get Personalized videos with our Advanced/Custom Editing services",
    perfectFor: ["Commercial Videos", "Branded content"],
    featureOverview: [
      "Motion graphics elements",
      "Brand Guidelines Alignment",
      "Professional Color Grading",
      "License-Free Music and Sound effects",
      "Advanced animation and 3d effects",
      "Custom Intro & Outro",
    ],
    btnText: "Choose Motion Graphics / 3D",
  },
];

export const VideoGrapher_Driven_Plans = [
  {
    videoType: "budget-shoot",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Budget+Shoot.webp",
    planName: "Budget Shoot",
    planPrice_in_text: "7,999",
    price: 7999,
    description:
      "Affordable, high-quality videos perfect for startups and small businesses",
    perfectFor: ["Testimonial Videos", "Product Shoots"],
    featureOverview: [
      "Video Duration of 2-3 mins",
      "Basic lighting setup",
      "Simple/Greenscreen background",
      "Standard audio recordings",
      "Basic Editing",
      "Questionnaire Preparation",
    ],
    btnText: "Choose Budget",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Cinematic+shoot.webp",
    videoType: "cinematic-shoot",
    planName: "Cinematic shoot",
    planPrice_in_text: "25,000",
    price: 25000,
    description:
      "Professional-grade video production for a polished, cinematic look",
    perfectFor: ["Testimonial Videos", "Product Shoots"],
    featureOverview: [
      "Video Duration of 2-3 mins",
      "Advanced lighting setup",
      "Customized Background/ Studio/ Green screen",
      "High-Quality audio recording",
      "Enterprise Grade Editing",
      "Multi-Camera Angles",
      "Questionnaire Preparation",
      "1 Free Micro-Content Clip (Under 1 min)",
    ],
    btnText: "Choose Cinematic",
  },
  {
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/Cinematic-Extended+Shoot.webp",
    videoType: "cinematic-extended-shoot",
    planName: "Cinematic-Extended Shoot",
    planPrice_in_text: "45,000",
    price: 450000,
    description:
      "Extended cinematic storytelling for detailed narratives and in-depth projects",
    perfectFor: ["Case Study Videos", "Product Descriptions"],
    featureOverview: [
      "Video Duration of 3-5 mins",
      "Professional lighting setup",
      "Customized Background/ Studio/ Green screen",
      "High-Quality microphones (noise reduction)",
      "Enterprise Grade Editing",
      "Multi-Camera Angles",
      "2 Free Micro-Content Clip (Under 1 min)",
      "B-Roll Shoot",
      "Make-up Artist",
    ],
    btnText: "Choose Cinematic - Extended",
  },
];

export const SidebarLinks: SidebarLink[] = [
  {
    id: "dashboard",
    icon: <DashboardIcon />,
    element: <Dashboard />,
    label: "Dashboard",
    path: "dashboard",
    isNew: false,
  },
  {
    icon: <ProjectsIcon />,
    element: <Projects />,
    label: "Projects",
    id: "projects",
    path: "projects",
    isNew: false,
  },
  {
    icon: <JobsIcon />,
    element: <Jobs />,
    label: "Jobs for you",
    id: "jobs",
    path: "jobs",
    isNew: false,
  },
  {
    icon: <MessagesIcon />,
    element: <MessagingDashboard />,
    label: "Messages",
    id: "messages",
    path: "messages",
    isNew: false,
  },
  // {
  //   icon: <DashboardIcon />,
  //   element: <Profile />,
  //   label: "Profile",
  //   id: "profile",
  //   path: "profile",
  //   isNew: false,
  // },
  {
    icon: <NotificationsIcon />,
    element: <Notifications />,
    label: "Notification",
    id: "notification",
    path: "notification",
    isNew: false,
  },
];
export const MobileBottomNav: SidebarLink[] = [
  {
    icon: <DashboardIcon />,
    element: <Dashboard />,
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: <JobsIcon />,
    element: <Jobs />,
    label: "Jobs",
    path: "/jobs",
  },
  {
    label: "Project",
    icon: <ProjectsIcon />,
    element: <Projects />,
    path: "/projects",
  },
  {
    icon: <WalletIcon />,
    element: <Wallet />,
    label: "Wallet",
    path: "/wallet",
  },
];
export const OtherLinks: SidebarLink[] = [
  // {
  //   icon: <WalletIcon />,
  //   element: <Wallet />,
  //   label: "Wallet",
  //   id: "wallet",
  //   path: "wallet",
  // },
  // {
  //   icon: <InvoiceIcon />,
  //   element: <Dashboard />,
  //   label: "Billing and Invoices",
  //   path: "billings",
  // },
];

export const PersonalLinks: SidebarLink[] = [
  // {
  //   icon: <SettingIcon />,
  //   element: <Setting />,
  //   label: "Setting",
  //   path: "setting",
  // },
  // {
  //   icon: <Question />,
  //   element: <Help />,
  //   label: "Help and Feedback",
  //   path: "help",
  // },
];
export const DistributionOptions = [
  {
    id: "social-media",
    title: "Social media",
  },
  {
    id: "company-Website",
    title: "Company Website",
  },

  {
    id: "youtube",
    title: "Youtube",
  },
  {
    id: "meta/googleads",
    title: "Meta / Google Ads",
  },
  {
    id: "others",
    title: "Others",
  },
];
export const targetAudienceOptions = [
  { id: "1", title: "Adults" },
  { id: "2", title: "Teens" },
  { id: "3", title: "Children" },
  { id: "4", title: "Seniors" },
  { id: "5", title: "Professionals" },
];
export const LanguageOptions = [
  { id: "1", title: "English" },
  { id: "112", title: "Hindi" },
  { id: "2", title: "Bengali" },
  { id: "3", title: "Telugu" },
  { id: "4", title: "Marathi" },
  { id: "5", title: "Tamil" },
  { id: "6", title: "Gujarati" },
  { id: "7", title: "Urdu" },
  { id: "8", title: "Kannada" },
  { id: "9", title: "Odia" },
  { id: "10", title: "Punjabi" },
];

export const HaveAScriptOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No, I need help",
  },
];

export const PrimaryGoalOptions = [
  "Promoting a Product / Service",
  "Entertain",
  "Educate (Or) Inform Audience",
  "Others",
];

export const ToneOfVideoOptions = [
  {
    video: true,
    title: "Professional",
    url: Professional,
  },
  {
    video: true,
    title: "Casual",
    url: Casual,
  },
  {
    video: true,
    title: "Dramatic",
    url: Dramatic,
  },
  {
    video: true,
    title: "Humorous",
    url: Humorous,
  },
  {
    video: false,
    title: "Others",
  },
];

export const DeliverySlotOptions = [
  {
    days: 7,
    title: "5-8 Working Days",
    desc: "Standard Delivery",
    extraCharge: 0,
  },

  {
    days: 3,
    title: "72 Hours (3 Working Days)",
    desc: `Express Delivery  •  50% of the order value`,
    extraCharge: 50,
  },
];

export const FormatOptions = [
  {
    img: PotraitImag,
    title: "Portrait (9:16)",
  },
  {
    img: LanscapeImg,
    title: "Landscape (16:9)",
  },
];

export const VideoBgOptions = [
  {
    img: HomeBg,
    title: "Home Background",
  },
  {
    img: VisualBg,
    title: "Visual background",
  },
];

export const AdditionaInfoOptions = [
  {
    id: "1",
    icon: <NotesIcon />,
    title: "Add Notes",
  },
  {
    id: "2",
    icon: <FileIcon />,
    title: "Upload files & Links",
  },
];

export const YesOrNoOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No",
  },
];

export const videoEditStyle = [
  {
    img: Style1Image,
    title: "Picture - In - Picture",
    desc: " Live Product Demonstration Where Actor and Visuals happen in Same Frame",
  },
  {
    img: Style1Image,
    title: "Actor and Visual Movement",
    desc: "Actor-focused with basic visuals and minimal edits.",
  },
  {
    img: Style1Image,
    title: "Stock Video with Voiceover",
    desc: "The actor narrates over stock footage.",
  },
  {
    img: Style1Image,
    title: "Live Product Demonstration",
    desc: "The actor showcases the product live.",
  },
];

export const MenBodyTypeOptions = [
  {
    id: "1",
    img: AverageMenBody,
    title: "Average",
  },
  {
    id: "2",
    img: SlimMenBody,
    title: "Slim",
  },
  {
    id: "3",
    img: AthleticMenBody,
    title: "Athletic",
  },
  {
    id: "4",
    img: PlusSizeMenBody,
    title: "Plus-Size",
  },
  {
    id: "5",
    img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
    title: "No Preferences",
  },
];

export const MenSkinToneOptions = [
  {
    id: "1",
    img: MenFairSkinned,
    title: "Fair-Skinned",
  },
  {
    id: "2",
    img: MenBrownSkinned,
    title: "Brown-Skinned",
  },
  {
    id: "3",
    img: MenDarkSkinned,
    title: "Dark-Skinned",
  },

  {
    id: "5",
    img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
    title: "No Preferences",
  },
];

export const WomenBodyTypeOptions = [
  {
    id: "1",
    img: WomenAverage,
    title: "Average",
  },
  {
    id: "2",
    img: WomenSlim,
    title: "Slim",
  },
  {
    id: "3",
    img: WomenAthletic,
    title: "Athletic",
  },
  {
    id: "4",
    img: WomenPlusSize,
    title: "Plus-Size",
  },
  {
    id: "5",
    img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
    title: "No Preferences",
  },
];
export const WomenSkinToneOptions = [
  {
    id: "1",
    img: WomenFairSkinned,
    title: "Fair-Skinned",
  },
  {
    id: "2",
    img: WomenBrownSkinned,
    title: "Brown-Skinned",
  },
  {
    id: "3",
    img: WomenDarkSkinned,
    title: "Dark-Skinned",
  },

  {
    id: "5",
    img: "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/noPreference.png",
    title: "No Preferences",
  },
];

export const PersonaStylesOptions = [
  "Casual",
  "Professional",
  "Formal",
  "Semi-formal",
  "Others",
];

export const WomenWardrobStyleOptions = [
  {
    active: true,
    id: "1",
    img: WomenCasualWear,
    title: "Casual Wear",
  },
  {
    id: "2",
    img: WomenBusinessWear,
    title: "Business attire",
  },
  {
    id: "3",
    img: WomenTraditionalWear,
    title: "Traditional attire",
  },
  {
    id: "4",
    img: WomenSportsWear,
    title: "Sports attire",
  },
];

export const MenWardrobStyleOptions = [
  {
    active: true,
    id: "1",
    img: MenCasualWear,
    title: "Casual Wear",
  },
  {
    id: "2",
    img: MenBusinessWear,
    title: "Business attire",
  },
  {
    id: "3",
    img: MenTraditionalWear,
    title: "Traditional attire",
  },
  {
    id: "4",
    img: MenSportsWear,
    title: "Sports attire",
  },
];

export const countryOptions = [
  { value: "+1", label: "US" },
  { value: "+33", label: "FR" },
  { value: "+44", label: "UK" },
  { value: "+91", label: "IN" },
  { value: "+93", label: "AF" },
  { value: "+355", label: "AL" },
  { value: "+213", label: "DZ" },
  { value: "+376", label: "AD" },
  { value: "+244", label: "AO" },
  { value: "+672", label: "AQ" },
  { value: "+54", label: "AR" },
  { value: "+374", label: "AM" },
  { value: "+297", label: "AW" },
  { value: "+61", label: "AU" },
  { value: "+43", label: "AT" },
  { value: "+994", label: "AZ" },
  { value: "+973", label: "BH" },
  { value: "+880", label: "BD" },
  { value: "+375", label: "BY" },
  { value: "+32", label: "BE" },
  { value: "+501", label: "BZ" },
  { value: "+229", label: "BJ" },
  { value: "+975", label: "BT" },
  { value: "+591", label: "BO" },
  { value: "+387", label: "BA" },
  { value: "+267", label: "BW" },
  { value: "+55", label: "BR" },
  { value: "+673", label: "BN" },
  { value: "+359", label: "BG" },
  { value: "+226", label: "BF" },
  { value: "+257", label: "BI" },
  { value: "+855", label: "KH" },
  { value: "+237", label: "CM" },
  { value: "+238", label: "CV" },
  { value: "+236", label: "CF" },
  { value: "+235", label: "TD" },
  { value: "+56", label: "CL" },
  { value: "+86", label: "CN" },
  { value: "+57", label: "CO" },
  { value: "+269", label: "KM" },
  { value: "+243", label: "CD" },
  { value: "+242", label: "CG" },
  { value: "+506", label: "CR" },
  { value: "+385", label: "HR" },
  { value: "+53", label: "CU" },
  { value: "+357", label: "CY" },
  { value: "+420", label: "CZ" },
  { value: "+45", label: "DK" },
  { value: "+253", label: "DJ" },
  { value: "+670", label: "TL" },
  // Additional European countries
  { value: "+372", label: "EE" },
  { value: "+358", label: "FI" },
  { value: "+49", label: "DE" },
  { value: "+30", label: "GR" },
  { value: "+36", label: "HU" },
  { value: "+353", label: "IE" },
  { value: "+39", label: "IT" },
  { value: "+371", label: "LV" },
  { value: "+370", label: "LT" },
  { value: "+352", label: "LU" },
  { value: "+31", label: "NL" },
  { value: "+48", label: "PL" },
  { value: "+351", label: "PT" },
  { value: "+40", label: "RO" },
  { value: "+7", label: "RU" },
  { value: "+381", label: "RS" },
  { value: "+421", label: "SK" },
  { value: "+386", label: "SI" },
  { value: "+34", label: "ES" },
  { value: "+46", label: "SE" },
  { value: "+41", label: "CH" },
  { value: "+380", label: "UA" },
  // Additional Asian countries
  { value: "+374", label: "AM" },
  { value: "+994", label: "AZ" },
  { value: "+973", label: "BH" },
  { value: "+673", label: "BN" },
  { value: "+86", label: "CN" },
  { value: "+852", label: "HK" },
  { value: "+91", label: "IN" },
  { value: "+62", label: "ID" },
  { value: "+98", label: "IR" },
  { value: "+964", label: "IQ" },
  { value: "+972", label: "IL" },
  { value: "+81", label: "JP" },
  { value: "+962", label: "JO" },
  { value: "+7", label: "KZ" },
  { value: "+965", label: "KW" },
  { value: "+996", label: "KG" },
  { value: "+856", label: "LA" },
  { value: "+961", label: "LB" },
  { value: "+960", label: "MV" },
  { value: "+976", label: "MN" },
  { value: "+95", label: "MM" },
  { value: "+977", label: "NP" },
  { value: "+968", label: "OM" },
  { value: "+92", label: "PK" },
  { value: "+974", label: "QA" },
  { value: "+966", label: "SA" },
  { value: "+65", label: "SG" },
  { value: "+82", label: "KR" },
  { value: "+94", label: "LK" },
  { value: "+963", label: "SY" },
  { value: "+66", label: "TH" },
  { value: "+90", label: "TR" },
  { value: "+971", label: "AE" },
  { value: "+998", label: "UZ" },
  { value: "+84", label: "VN" },
  { value: "+967", label: "YE" },
  { value: "+502", label: "GT" },
  { value: "+254", label: "KEN" },
  { value: "+256", label: "UGA" },
];

export const GenderOptions = ["Male", "Female", "Either"];
export const AgeGroupOptions = [
  // {
  //   disabled: true,
  //   label: `Kids (<span class='font-medium text-[#17457D]'>Coming soon</span>) `,
  // },
  {
    disabled: false,
    ageRange: {
      min: 13,
      max: 18,
    },
    label: "Teens (13-18 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 19,
      max: 29,
    },
    label: "Young Adults (19-29 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 30,
      max: 45,
    },
    label: "Adults (30-45 years)",
  },
  {
    disabled: false,
    ageRange: {
      min: 46,
      max: 60,
    },
    label: "Middle-Aged (46-60 years)",
  },
  // {
  //   disabled: true,
  //   label: `Seniors (<span class='font-medium text-[#17457D]'>Coming soon</span>) `,
  // },
];

export const OtherDetailOptions = [
  {
    value: true,
    title: "Yes",
  },
  {
    value: false,
    title: "No",
  },
];

export const Pricing_Plan_contents = [
  {
    planName: "Starter Plan",
    pricebyMonth: "₹35k",
    actualPrice: 35000,
    description: "For new and small businesses",
    creditsAllotted: "35,000",
    features: [
      "1000+ creators to choose from",
      "High-quality video output",
      "Full-time contact support",
      "Up to 2 revisions",
      "Home-Studio Plan at ₹3999/- with Discount",
    ],
    isPopular: false,
  },
  {
    planName: "Standard Plan",
    pricebyMonth: "₹85k",
    actualPrice: 85000,
    description: "For growing businesses",
    creditsAllotted: "85,000 + 4250  Extra 5%",
    extraCreditsPercentage: 5,
    features: [
      "Everything in Starter Plan",
      "Dedicated video marketing strategist",
      "Up to 3 revisions",
      "More value for money",
    ],
    isPopular: true,
  },

  {
    planName: "Enterprise Plan",
    pricebyMonth: "₹2.56L",
    actualPrice: 256000,
    description: "For large enterprises needing scalable solutions",
    creditsAllotted: "2,56,000 + Extra 10% ",
    extraCreditsPercentage: 10,
    features: [
      "Everything in Standard Plan",
      "High-quality video output",
      "Up to 4 revisions",
      "More value for money",
      `Faster delivery at no extra cost`,
      "Extensions on feedback and approval timelines",
    ],
    isPopular: false,
  },
];

type TPlanPricingStructure = {
  pricingType: "fixed" | "dynamic";
  fixedPrice?: number; // For fixed-price plans like Home Studio
  dynamicPricing?: {
    minDuration: number; // in seconds
    maxDuration: number | null; // in seconds or null for no upper bound
    pricePerMinute: number;
  }[]; // For dynamic pricing plans like Professional Studio
};

type TPlanDetails = {
  _id: string;
  videoType: string;
  image: string;
  planName: string;
  price: number;
  planPrice_in_text: string;
  description: string;
  perfectFor: string[];
  featureOverview: string[];
  btnText: string;
  pricingStructure: TPlanPricingStructure;
};

const homeStudioPlan: TPlanDetails = {
  _id: "66b43526c9315c880baa3c1d",
  videoType: "66b3832e9101b4496a359ded",
  image:
    "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
  planName: "Home Studio",
  price: 3999,
  planPrice_in_text: "3999",
  description:
    "Unlock Professional marketing videos from home with our Actor-Driven Plan",
  perfectFor: ["Spoke Person Videos", "Promotional Videos"],
  featureOverview: [
    "Own Home-studio environment",
    "Actor/Spokesperson",
    "Casual/Business Attire Options",
    "Home Studio (iPhone Quality)",
    "Standard Equipment",
    "Basic editing",
    "View Video Samples",
    "Choose Home - Studio",
  ],
  btnText: "Choose Home-Studio",
  pricingStructure: {
    pricingType: "fixed",
    fixedPrice: 3999,
  },
};

const professionalStudioPlan: TPlanDetails = {
  _id: "66b43526c9315c880baa3c1d",
  videoType: "66b3832e9101b4496a359ded",
  image:
    "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/professional-studio-cover.webp",
  planName: "Professional Studio",
  price: 0, // will be calculated based on duration
  planPrice_in_text: "Dynamic Pricing",
  description:
    "Unlock Professional marketing videos with top-tier studio quality",
  perfectFor: ["Corporate Videos", "Product Demos"],
  featureOverview: [
    "Professional Studio environment",
    "Actor/Spokesperson",
    "Business Attire Options",
    "4K Quality",
    "Advanced Equipment",
    "Pro editing",
    "View Video Samples",
    "Choose Professional Studio",
  ],
  btnText: "Choose Professional-Studio",
  pricingStructure: {
    pricingType: "dynamic",
    dynamicPricing: [
      { minDuration: 0, maxDuration: 90, pricePerMinute: 17500 },
      { minDuration: 91, maxDuration: 300, pricePerMinute: 14000 },
      { minDuration: 301, maxDuration: 420, pricePerMinute: 12000 },
      { minDuration: 421, maxDuration: null, pricePerMinute: 10500 },
    ],
  },
};

export const TempActorDrivenData: PlanDetailsTypes[] = [
  {
    _id: "66b43526c9315c880baa3c1d",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/home-studio-cover.webp",
    planName: "Home Studio",
    price: 3999,
    planPrice_in_text: "3999",
    description:
      "Unlock Professional marketing videos from home with our Actor-Driven Plan",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Own Home-studio environment",
      "Actor/Spokesperson",
      "Casual/Business Attire Options",
      "Home Studio (iPhone Quality)",
      "Standard Equipment",
      "Basic editing",
      "View Video Samples",
      "Choose Home - Studio",
    ],
    btnText: "Choose Home-Studio",
    pricingStructure: {
      pricingType: "fixed",
      fixedPrice: 3999,
    },
  },
  {
    _id: "66b43526c9315c880baa3c1e",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/proffessional-studio.webp",
    planName: "Professional Studio",
    price: 17500,
    planPrice_in_text: "17,500",
    description:
      "Access Professional studio equipment for polished video production.",
    perfectFor: ["Spoke Person Videos", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Experienced Actor/Spokesperson",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "High-Quality Equipment",
      "Standard Editing",
      "View Video Samples",
      "Choose Professional - Studio",
    ],
    btnText: "Choose Professional-Studio",
    pricingStructure: {
      pricingType: "dynamic",
      dynamicPricing: [
        { minDuration: 0, maxDuration: 90, pricePerMinute: 17500 },
        { minDuration: 91, maxDuration: 300, pricePerMinute: 14000 },
        { minDuration: 301, maxDuration: 420, pricePerMinute: 12000 },
        { minDuration: 421, maxDuration: null, pricePerMinute: 10500 },
      ],
    },
  },
  {
    comingSoon: true,
    _id: "66b43526c9315c880baa3c1f",
    videoType: "66b3832e9101b4496a359ded",
    image:
      "https://passionbits-v2-dashboard-public-assets.s3.ap-south-1.amazonaws.com/multi-actor-cover.webp",
    planName: "Multi-Actor",
    price: 35000,
    planPrice_in_text: "35,000",
    description:
      "Engage with our Skit/Live Action plan featuring multiple action and live-action scenes",
    perfectFor: ["Brand Storytelling", "Promotional Videos"],
    featureOverview: [
      "Professional Environment",
      "Professional Actor/Spokesperson",
      "Multiple Actors",
      "Studio Aesthetic",
      "Comprehensive Wardrobe options",
      "Studio quality (DSLR 1440p)",
      "Enterprise grade editing",
      "View Video Samples",
      "Choose Multi-Actor",
    ],
    btnText: "Choose Multi-Actor",
    pricingStructure: {
      pricingType: "fixed",
      fixedPrice: 3999,
    },
  },
];

export const skinTone: SelectComponetOption[] = [
  { id: "Fair-Skinned", title: "Fair-Skinned" },
  { id: "Brown-Skinned", title: "Brown-Skinned" },
  { id: "Dark-Skinned", title: "Dark-Skinned" },
  { id: "No Preference", title: "No Preference" },
];

export const bodyType: SelectComponetOption[] = [
  { id: "Average", title: "Average" },
  { id: "Slim", title: "Slim" },
  { id: "Athletic", title: "Athletic" },
  { id: "Plus-Size", title: "Plus-Size" },
  { id: "No Preferences", title: "No Preferences" },
];

export const videoShootingPropsOptions: SelectComponetOption[] = [
  { id: "Gadgets", title: "Gadgets (Extra Phone, Laptop, Tablet, etc)" },
  { id: "Utilities", title: "Utilities (Hairdryer, Table, Mirror, etc)" },
  { id: "Pets", title: "Pet(s)" },
  { id: "Vehicles", title: "Vehicle(s)" },
  { id: "Peer_Actor", title: "Peer actor/presenter" },
  { id: "Kitchen", title: "Kitchen - Cooking/Recipe reviews" },
];
type SelectOption = {
  id: string;
  title: string;
};

// Constants and Data
export const GENDER_OPTIONS: SelectOption[] = [
  { id: "Male", title: "Male" },
  { id: "Female", title: "Female" },
  { id: "Other", title: "Other" },
];

export const AGE_RANGES: SelectOption[] = [
  { id: "18-24", title: "18-24 years" },
  { id: "25-34", title: "25-34 years" },
  { id: "35-44", title: "35-44 years" },
  { id: "45-54", title: "45-54 years" },
  { id: "55+", title: "55+ years" },
];

export const COUNTRIES: SelectOption[] = [
  { id: "af", title: "Afghanistan" },
  { id: "al", title: "Albania" },
  { id: "dz", title: "Algeria" },
  { id: "ad", title: "Andorra" },
  { id: "ao", title: "Angola" },
  { id: "ag", title: "Antigua and Barbuda" },
  { id: "ar", title: "Argentina" },
  { id: "am", title: "Armenia" },
  { id: "au", title: "Australia" },
  { id: "at", title: "Austria" },
  { id: "az", title: "Azerbaijan" },
  { id: "bs", title: "Bahamas" },
  { id: "bh", title: "Bahrain" },
  { id: "bd", title: "Bangladesh" },
  { id: "bb", title: "Barbados" },
  { id: "by", title: "Belarus" },
  { id: "be", title: "Belgium" },
  { id: "bz", title: "Belize" },
  { id: "bj", title: "Benin" },
  { id: "bt", title: "Bhutan" },
  { id: "bo", title: "Bolivia" },
  { id: "ba", title: "Bosnia and Herzegovina" },
  { id: "bw", title: "Botswana" },
  { id: "br", title: "Brazil" },
  { id: "bn", title: "Brunei" },
  { id: "bg", title: "Bulgaria" },
  { id: "bf", title: "Burkina Faso" },
  { id: "bi", title: "Burundi" },
  { id: "cv", title: "Cabo Verde" },
  { id: "kh", title: "Cambodia" },
  { id: "cm", title: "Cameroon" },
  { id: "ca", title: "Canada" },
  { id: "cf", title: "Central African Republic" },
  { id: "td", title: "Chad" },
  { id: "cl", title: "Chile" },
  { id: "cn", title: "China" },
  { id: "co", title: "Colombia" },
  { id: "km", title: "Comoros" },
  { id: "cg", title: "Congo (Republic)" },
  { id: "cd", title: "Congo (DRC)" },
  { id: "cr", title: "Costa Rica" },
  { id: "ci", title: "Côte d’Ivoire" },
  { id: "hr", title: "Croatia" },
  { id: "cu", title: "Cuba" },
  { id: "cy", title: "Cyprus" },
  { id: "cz", title: "Czech Republic" },
  { id: "dk", title: "Denmark" },
  { id: "dj", title: "Djibouti" },
  { id: "dm", title: "Dominica" },
  { id: "do", title: "Dominican Republic" },
  { id: "ec", title: "Ecuador" },
  { id: "eg", title: "Egypt" },
  { id: "sv", title: "El Salvador" },
  { id: "gq", title: "Equatorial Guinea" },
  { id: "er", title: "Eritrea" },
  { id: "ee", title: "Estonia" },
  { id: "sz", title: "Eswatini" },
  { id: "et", title: "Ethiopia" },
  { id: "fj", title: "Fiji" },
  { id: "fi", title: "Finland" },
  { id: "fr", title: "France" },
  { id: "ga", title: "Gabon" },
  { id: "gm", title: "Gambia" },
  { id: "ge", title: "Georgia" },
  { id: "de", title: "Germany" },
  { id: "gh", title: "Ghana" },
  { id: "gr", title: "Greece" },
  { id: "gd", title: "Grenada" },
  { id: "gt", title: "Guatemala" },
  { id: "gn", title: "Guinea" },
  { id: "gw", title: "Guinea-Bissau" },
  { id: "gy", title: "Guyana" },
  { id: "ht", title: "Haiti" },
  { id: "hn", title: "Honduras" },
  { id: "hu", title: "Hungary" },
  { id: "is", title: "Iceland" },
  { id: "in", title: "India" },
  { id: "id", title: "Indonesia" },
  { id: "ir", title: "Iran" },
  { id: "iq", title: "Iraq" },
  { id: "ie", title: "Ireland" },
  { id: "il", title: "Israel" },
  { id: "it", title: "Italy" },
  { id: "jm", title: "Jamaica" },
  { id: "jp", title: "Japan" },
  { id: "jo", title: "Jordan" },
  { id: "kz", title: "Kazakhstan" },
  { id: "ke", title: "Kenya" },
  { id: "ki", title: "Kiribati" },
  { id: "kp", title: "North Korea" },
  { id: "kr", title: "South Korea" },
  { id: "kw", title: "Kuwait" },
  { id: "kg", title: "Kyrgyzstan" },
  { id: "la", title: "Laos" },
  { id: "lv", title: "Latvia" },
  { id: "lb", title: "Lebanon" },
  { id: "ls", title: "Lesotho" },
  { id: "lr", title: "Liberia" },
  { id: "ly", title: "Libya" },
  { id: "li", title: "Liechtenstein" },
  { id: "lt", title: "Lithuania" },
  { id: "lu", title: "Luxembourg" },
  { id: "mg", title: "Madagascar" },
  { id: "mw", title: "Malawi" },
  { id: "my", title: "Malaysia" },
  { id: "mv", title: "Maldives" },
  { id: "ml", title: "Mali" },
  { id: "mt", title: "Malta" },
  { id: "mh", title: "Marshall Islands" },
  { id: "mr", title: "Mauritania" },
  { id: "mu", title: "Mauritius" },
  { id: "mx", title: "Mexico" },
  { id: "fm", title: "Micronesia" },
  { id: "md", title: "Moldova" },
  { id: "mc", title: "Monaco" },
  { id: "mn", title: "Mongolia" },
  { id: "me", title: "Montenegro" },
  { id: "ma", title: "Morocco" },
  { id: "mz", title: "Mozambique" },
  { id: "mm", title: "Myanmar" },
  { id: "na", title: "Namibia" },
  { id: "nr", title: "Nauru" },
  { id: "np", title: "Nepal" },
  { id: "nl", title: "Netherlands" },
  { id: "nz", title: "New Zealand" },
  { id: "ni", title: "Nicaragua" },
  { id: "ne", title: "Niger" },
  { id: "ng", title: "Nigeria" },
  { id: "mk", title: "North Macedonia" },
  { id: "no", title: "Norway" },
  { id: "om", title: "Oman" },
  { id: "pk", title: "Pakistan" },
  { id: "pw", title: "Palau" },
  { id: "pa", title: "Panama" },
  { id: "pg", title: "Papua New Guinea" },
  { id: "py", title: "Paraguay" },
  { id: "pe", title: "Peru" },
  { id: "ph", title: "Philippines" },
  { id: "pl", title: "Poland" },
  { id: "pt", title: "Portugal" },
  { id: "qa", title: "Qatar" },
  { id: "ro", title: "Romania" },
  { id: "ru", title: "Russia" },
  { id: "rw", title: "Rwanda" },
  { id: "kn", title: "Saint Kitts and Nevis" },
  { id: "lc", title: "Saint Lucia" },
  { id: "vc", title: "Saint Vincent and the Grenadines" },
  { id: "ws", title: "Samoa" },
  { id: "sm", title: "San Marino" },
  { id: "st", title: "Sao Tome and Principe" },
  { id: "sa", title: "Saudi Arabia" },
  { id: "sn", title: "Senegal" },
  { id: "rs", title: "Serbia" },
  { id: "sc", title: "Seychelles" },
  { id: "sl", title: "Sierra Leone" },
  { id: "sg", title: "Singapore" },
  { id: "sk", title: "Slovakia" },
  { id: "si", title: "Slovenia" },
  { id: "sb", title: "Solomon Islands" },
  { id: "so", title: "Somalia" },
  { id: "za", title: "South Africa" },
  { id: "ss", title: "South Sudan" },
  { id: "es", title: "Spain" },
  { id: "lk", title: "Sri Lanka" },
  { id: "sd", title: "Sudan" },
  { id: "sr", title: "Suriname" },
  { id: "se", title: "Sweden" },
  { id: "ch", title: "Switzerland" },
  { id: "sy", title: "Syria" },
  { id: "tw", title: "Taiwan" },
  { id: "tj", title: "Tajikistan" },
  { id: "tz", title: "Tanzania" },
  { id: "th", title: "Thailand" },
  { id: "tl", title: "Timor-Leste" },
  { id: "tg", title: "Togo" },
  { id: "to", title: "Tonga" },
  { id: "tt", title: "Trinidad and Tobago" },
  { id: "tn", title: "Tunisia" },
  { id: "tr", title: "Turkey" },
  { id: "tm", title: "Turkmenistan" },
  { id: "tv", title: "Tuvalu" },
  { id: "ug", title: "Uganda" },
  { id: "ua", title: "Ukraine" },
  { id: "ae", title: "United Arab Emirates" },
  { id: "gb", title: "United Kingdom" },
  { id: "us", title: "United States" },
  { id: "uy", title: "Uruguay" },
  { id: "uz", title: "Uzbekistan" },
  { id: "vu", title: "Vanuatu" },
  { id: "va", title: "Vatican City" },
  { id: "ve", title: "Venezuela" },
  { id: "vn", title: "Vietnam" },
  { id: "ye", title: "Yemen" },
  { id: "zm", title: "Zambia" },
  { id: "zw", title: "Zimbabwe" },
];

export const INDIAN_STATES: SelectOption[] = [
  { id: "mh", title: "Maharashtra" },
  { id: "tn", title: "Tamil Nadu" },
  { id: "ka", title: "Karnataka" },
  { id: "dl", title: "Delhi" },
  { id: "wb", title: "West Bengal" },
  { id: "up", title: "Uttar Pradesh" },
  { id: "gj", title: "Gujarat" },
  { id: "rj", title: "Rajasthan" },
  { id: "pb", title: "Punjab" },
  { id: "or", title: "Odisha" },
  // Add more Indian states as needed
];

export const MAJOR_CITIES: SelectOption[] = [
  { id: "mum", title: "Mumbai" },
  { id: "del", title: "Delhi" },
  { id: "blr", title: "Bengaluru" },
  { id: "chn", title: "Chennai" },
  { id: "kol", title: "Kolkata" },
  { id: "hyd", title: "Hyderabad" },
  { id: "ahm", title: "Ahmedabad" },
  { id: "pune", title: "Pune" },
  { id: "jai", title: "Jaipur" },
  { id: "cbe", title: "Coimbatore" },
  // { id: "gt", title: "Gutamela City" },
  // Add more major cities in India as needed
];

export const TIMEZONES: SelectOption[] = [
  { id: "est", title: "Eastern Time (ET)" },
  { id: "cst", title: "Central Time (CT)" },
  { id: "mst", title: "Mountain Time (MT)" },
  { id: "pst", title: "Pacific Time (PT)" },
  { id: "gmt", title: "Greenwich Mean Time (GMT)" },
  { id: "utc", title: "Universal Coordinated Time (UTC)" },
];
export const MAJOR_CITIES_BY_COUNTRY: Record<
  string,
  { id: string; title: string }[]
> = {
  India: [
    { id: "mum", title: "Mumbai" },
    { id: "lucknow", title: "Lucknow" },
    { id: "del", title: "Delhi" },
    { id: "blr", title: "Bengaluru" },
    { id: "hyd", title: "Hyderabad" },
    { id: "chn", title: "Chennai" },
    { id: "kol", title: "Kolkata" },
    { id: "ahm", title: "Ahmedabad" },
    { id: "pune", title: "Pune" },
    { id: "jai", title: "Jaipur" },
    { id: "cbe", title: "Coimbatore" },
    { id: "gt", title: "Gutamela City" },
  ],
  Pakistan: [
    { id: "khi", title: "Karachi" },
    { id: "lhr", title: "Lahore" },
    { id: "isb", title: "Islamabad" },
    { id: "rwp", title: "Rawalpindi" },
    { id: "fsd", title: "Faisalabad" },
  ],
  Bangladesh: [
    { id: "dac", title: "Dhaka" },
    { id: "ctg", title: "Chittagong" },
    { id: "khl", title: "Khulna" },
    { id: "raj", title: "Rajshahi" },
    { id: "syl", title: "Sylhet" },
  ],
  "Sri Lanka": [
    { id: "cmb", title: "Colombo" },
    { id: "kdy", title: "Kandy" },
    { id: "gal", title: "Galle" },
    { id: "jaf", title: "Jaffna" },
    { id: "neg", title: "Negombo" },
  ],
  Nepal: [
    { id: "ktm", title: "Kathmandu" },
    { id: "pok", title: "Pokhara" },
    { id: "lal", title: "Lalitpur" },
    { id: "bir", title: "Biratnagar" },
    { id: "brj", title: "Birgunj" },
  ],
  Malaysia: [
    { id: "kul", title: "Kuala Lumpur" },
    { id: "pen", title: "George Town" },
    { id: "jhb", title: "Johor Bahru" },
    { id: "iph", title: "Ipoh" },
    { id: "sha", title: "Shah Alam" },
  ],
  Singapore: [{ id: "sgp", title: "Singapore" }],
  Thailand: [
    { id: "bkk", title: "Bangkok" },
    { id: "cmi", title: "Chiang Mai" },
    { id: "hkt", title: "Phuket" },
    { id: "pty", title: "Pattaya" },
    { id: "hyi", title: "Hat Yai" },
  ],
  Vietnam: [
    { id: "han", title: "Hanoi" },
    { id: "sgn", title: "Ho Chi Minh City" },
    { id: "dad", title: "Da Nang" },
    { id: "hph", title: "Hai Phong" },
    { id: "vca", title: "Can Tho" },
  ],
  China: [
    { id: "pek", title: "Beijing" },
    { id: "sha", title: "Shanghai" },
    { id: "can", title: "Guangzhou" },
    { id: "szx", title: "Shenzhen" },
    { id: "ctu", title: "Chengdu" },
  ],
  Hungary: [
    { id: "buh", title: "Budapest" },
    { id: "deb", title: "Debrecen" },
    { id: "szg", title: "Szeged" },
    { id: "mis", title: "Miskolc" },
    { id: "pec", title: "Pécs" },
  ],
  Canada: [
    { id: "tor", title: "Toronto" },
    { id: "van", title: "Vancouver" },
    { id: "mtl", title: "Montreal" },
    { id: "cal", title: "Calgary" },
    { id: "ott", title: "Ottawa" },
  ],
  France: [
    { id: "par", title: "Paris" },
    { id: "mrs", title: "Marseille" },
    { id: "lyo", title: "Lyon" },
    { id: "tls", title: "Toulouse" },
    { id: "nic", title: "Nice" },
  ],
  Mexico: [
    { id: "cdmx", title: "Mexico City" },
    { id: "gdl", title: "Guadalajara" },
    { id: "mty", title: "Monterrey" },
    { id: "pue", title: "Puebla" },
    { id: "tij", title: "Tijuana" },
  ],
  Belarus: [
    { id: "msq", title: "Minsk" },
    { id: "gom", title: "Gomel" },
    { id: "mog", title: "Mogilev" },
    { id: "vtb", title: "Vitebsk" },
    { id: "grd", title: "Grodno" },
  ],
  "South Africa": [
    { id: "jnb", title: "Johannesburg" },
    { id: "cpt", title: "Cape Town" },
    { id: "dur", title: "Durban" },
    { id: "pta", title: "Pretoria" },
    { id: "plz", title: "Port Elizabeth" },
  ],
  "United Kingdom": [
    { id: "lon", title: "London" },
    { id: "man", title: "Manchester" },
    { id: "bhm", title: "Birmingham" },
    { id: "gla", title: "Glasgow" },
    { id: "liv", title: "Liverpool" },
  ],
  "United States": [
    { id: "nyc", title: "New York City" },
    { id: "la", title: "Los Angeles" },
    { id: "chi", title: "Chicago" },
    { id: "hou", title: "Houston" },
    { id: "mia", title: "Miami" },
  ],
  Guatemala: [
    { id: "guatemala", title: "Guatemala" },
    { id: "quetzaltenango", title: "Quetzaltenango" },
    { id: "escuintla", title: "Escuintla" },
    { id: "izabal", title: "Izabal" },
    { id: "peten", title: "Petén" },
  ],
};
export const experienceLevel: SelectOption[] = [
  { id: "beginner", title: "Beginner" },
  { id: "amateur", title: "Amateur" },
  { id: "professional", title: "Professional" },
  { id: "seasoned", title: "Seasoned" },
  { id: "star", title: "Star/Lead Role" },
];

export const ORDER_PLANS_IDS = {
  HOME_STUDIO: "66b43526c9315c880baa3c1d",
  PROFESSIONAL_STUDIO: "66b43526c9315c880baa3c1e",
  CREATOR_CANVAS: "67f27fac8022b682aa4297ac",
};

export const MAJOR_CITIES_BY_STATE: Record<
  string, // country name
  Record<
    string, // state/province name
    { id: string; title: string }[]
  >
> = {
  India: {
    Maharashtra: [
      { id: "mum", title: "Mumbai" },
      { id: "pune", title: "Pune" },
      { id: "nag", title: "Nagpur" },
      { id: "nas", title: "Nashik" },
      { id: "aur", title: "Aurangabad" },
    ],
    UttarPradesh: [
      { id: "lko", title: "Lucknow" },
      { id: "kan", title: "Kanpur" },
      { id: "vns", title: "Varanasi" },
      { id: "agr", title: "Agra" },
      { id: "gzb", title: "Ghaziabad" },
    ],
    Delhi: [
      { id: "del", title: "Delhi" },
      { id: "nd", title: "New Delhi" },
    ],

    TamilNadu: [
      { id: "chn", title: "Chennai" },
      { id: "cbe", title: "Coimbatore" },
      { id: "mdr", title: "Madurai" },
      { id: "slm", title: "Salem" },
    ],
    WestBengal: [
      { id: "kol", title: "Kolkata" },
      { id: "asn", title: "Asansol" },
      { id: "dgp", title: "Durgapur" },
      { id: "sli", title: "Siliguri" },
    ],
    Gujarat: [
      { id: "ahm", title: "Ahmedabad" },
      { id: "srt", title: "Surat" },
      { id: "vdr", title: "Vadodara" },
      { id: "rjt", title: "Rajkot" },
    ],
    Rajasthan: [
      { id: "jai", title: "Jaipur" },
      { id: "jod", title: "Jodhpur" },
      { id: "uda", title: "Udaipur" },
      { id: "kota", title: "Kota" },
    ],
    AndhraPradesh: [
      { id: "vsk", title: "Visakhapatnam" },
      { id: "vij", title: "Vijayawada" },
      { id: "gnt", title: "Guntur" },
      { id: "nell", title: "Nellore" },
    ],
    Telangana: [
      { id: "hyd", title: "Hyderabad" },
      { id: "wrn", title: "Warangal" },
      { id: "nzb", title: "Nizamabad" },
      { id: "kmm", title: "Khammam" },
    ],
    MadhyaPradesh: [
      { id: "ind", title: "Indore" },
      { id: "bpl", title: "Bhopal" },
      { id: "jbp", title: "Jabalpur" },
      { id: "gwl", title: "Gwalior" },
    ],
    Bihar: [
      { id: "pat", title: "Patna" },
      { id: "gya", title: "Gaya" },
      { id: "bgh", title: "Bhagalpur" },
      { id: "mzb", title: "Muzaffarpur" },
    ],
    Punjab: [
      { id: "ldh", title: "Ludhiana" },
      { id: "amr", title: "Amritsar" },
      { id: "jld", title: "Jalandhar" },
      { id: "ptl", title: "Patiala" },
    ],
    Haryana: [
      { id: "fbd", title: "Faridabad" },
      { id: "ggn", title: "Gurgaon" },
      { id: "pnpt", title: "Panipat" },
      { id: "krl", title: "Karnal" },
    ],
    Karnataka: [
      { id: "blr", title: "Bengaluru" },
      { id: "mys", title: "Mysuru" },
      { id: "mng", title: "Mangaluru" },
      { id: "hub", title: "Hubballi" },
      { id: "dwd", title: "Dharwad" },
      { id: "blg", title: "Ballari" },
      { id: "shm", title: "Shivamogga" },
      { id: "dvg", title: "Davangere" },
      { id: "klb", title: "Kalaburagi" },
      { id: "bdr", title: "Bidar" },
      { id: "bjp", title: "Bijapur (Vijayapura)" },
      { id: "kop", title: "Koppal" },
      { id: "has", title: "Hassan" },
      { id: "chm", title: "Chikkamagaluru" },
      { id: "tpt", title: "Tumakuru" },
      { id: "mdr", title: "Mandya" },
      { id: "kar", title: "Karwar" },
      { id: "udg", title: "Udupi" },
      { id: "chtr", title: "Chitradurga" },
      { id: "ram", title: "Ramanagara" },
    ],
    Kerala: [
      { id: "tvm", title: "Thiruvananthapuram" },
      { id: "cok", title: "Kochi" },
      { id: "klr", title: "Kozhikode" },
      { id: "tcr", title: "Thrissur" },
    ],
    Odisha: [
      { id: "bbs", title: "Bhubaneswar" },
      { id: "ctc", title: "Cuttack" },
      { id: "rkl", title: "Rourkela" },
      { id: "smb", title: "Sambalpur" },
    ],
    Chhattisgarh: [
      { id: "rpr", title: "Raipur" },
      { id: "bsp", title: "Bhilai" },
      { id: "durg", title: "Durg" },
      { id: "btr", title: "Bilaspur" },
    ],
    Jharkhand: [
      { id: "rnc", title: "Ranchi" },
      { id: "jms", title: "Jamshedpur" },
      { id: "dhn", title: "Dhanbad" },
      { id: "bok", title: "Bokaro" },
    ],
    Assam: [
      { id: "guh", title: "Guwahati" },
      { id: "slg", title: "Silchar" },
      { id: "dbr", title: "Dibrugarh" },
      { id: "jrh", title: "Jorhat" },
    ],
    HimachalPradesh: [
      { id: "sml", title: "Shimla" },
      { id: "mnd", title: "Mandi" },
      { id: "sln", title: "Solan" },
      { id: "dhr", title: "Dharamshala" },
    ],
    Uttarakhand: [
      { id: "ddn", title: "Dehradun" },
      { id: "hrd", title: "Haridwar" },
      { id: "rsh", title: "Rishikesh" },
      { id: "nnt", title: "Nainital" },
    ],
    Goa: [
      { id: "pnj", title: "Panaji" },
      { id: "mrg", title: "Margao" },
      { id: "vsg", title: "Vasco da Gama" },
      { id: "mpt", title: "Mapusa" },
    ],
    Tripura: [
      { id: "agt", title: "Agartala" },
      { id: "udb", title: "Udaipur" },
      { id: "dhr", title: "Dharmanagar" },
      { id: "khl", title: "Kailasahar" },
    ],
    Meghalaya: [
      { id: "shl", title: "Shillong" },
      { id: "tura", title: "Tura" },
      { id: "jow", title: "Jowai" },
      { id: "bgh", title: "Baghmara" },
    ],
    Manipur: [
      { id: "imp", title: "Imphal" },
      { id: "thb", title: "Thoubal" },
      { id: "bsh", title: "Bishnupur" },
      { id: "chr", title: "Churachandpur" },
    ],
    Mizoram: [
      { id: "aiz", title: "Aizawl" },
      { id: "lgn", title: "Lunglei" },
      { id: "sai", title: "Saiha" },
      { id: "chp", title: "Champhai" },
    ],
    Nagaland: [
      { id: "koh", title: "Kohima" },
      { id: "dim", title: "Dimapur" },
      { id: "mkg", title: "Mokokchung" },
      { id: "tup", title: "Tuensang" },
    ],
    ArunachalPradesh: [
      { id: "itn", title: "Itanagar" },
      { id: "pas", title: "Pasighat" },
      { id: "roing", title: "Roing" },
      { id: "bom", title: "Bomdila" },
    ],
    Sikkim: [
      { id: "gnz", title: "Gangtok" },
      { id: "nml", title: "Namchi" },
      { id: "gzl", title: "Gyalshing" },
      { id: "mng", title: "Mangan" },
    ],
    AndamanAndNicobarIslands: [
      { id: "ptb", title: "Port Blair" },
      { id: "dig", title: "Diglipur" },
      { id: "hvl", title: "Havelock Island" },
      { id: "ncb", title: "Neil Island" },
    ],
    Chandigarh: [{ id: "chd", title: "Chandigarh" }],
    DadraAndNagarHaveliAndDamanAndDiu: [
      { id: "sil", title: "Silvassa" },
      { id: "daman", title: "Daman" },
      { id: "diu", title: "Diu" },
    ],
    Lakshadweep: [
      { id: "kvt", title: "Kavaratti" },
      { id: "amn", title: "Amini" },
      { id: "agn", title: "Agatti" },
      { id: "min", title: "Minicoy" },
    ],
  },

  Pakistan: {
    Punjab: [
      { id: "lhr", title: "Lahore" },
      { id: "fsd", title: "Faisalabad" },
      { id: "rwp", title: "Rawalpindi" },
    ],
    Sindh: [{ id: "khi", title: "Karachi" }],
    Islamabad: [{ id: "isb", title: "Islamabad" }],
  },

  Bangladesh: {
    Dhaka: [
      { id: "dac", title: "Dhaka" },
      { id: "nrb", title: "Narayanganj" },
      { id: "gaj", title: "Gazipur" },
    ],
    Chattogram: [
      { id: "ctg", title: "Chattogram" },
      { id: "cxb", title: "Cox's Bazar" },
      { id: "kum", title: "Kumira" },
    ],
    Khulna: [
      { id: "khl", title: "Khulna" },
      { id: "jss", title: "Jessore" },
      { id: "sat", title: "Satkhira" },
    ],
    Rajshahi: [
      { id: "raj", title: "Rajshahi" },
      { id: "bog", title: "Bogra" },
      { id: "nwd", title: "Natore" },
    ],
    Sylhet: [
      { id: "syl", title: "Sylhet" },
      { id: "mwl", title: "Moulvibazar" },
      { id: "hab", title: "Habiganj" },
    ],
    Barisal: [
      { id: "brs", title: "Barisal" },
      { id: "ptu", title: "Patuakhali" },
      { id: "bhp", title: "Bhola" },
    ],
    Mymensingh: [
      { id: "mym", title: "Mymensingh" },
      { id: "ntl", title: "Netrakona" },
    ],
    Rangpur: [
      { id: "rng", title: "Rangpur" },
      { id: "din", title: "Dinajpur" },
      { id: "kur", title: "Kurigram" },
    ],
  },
  "United Kingdom": {
    England: [
      { id: "lon", title: "London" },
      { id: "man", title: "Manchester" },
      { id: "bhm", title: "Birmingham" },
      { id: "lds", title: "Leeds" },
      { id: "lvp", title: "Liverpool" },
    ],
    Scotland: [
      { id: "edi", title: "Edinburgh" },
      { id: "gla", title: "Glasgow" },
    ],
    Wales: [
      { id: "cdf", title: "Cardiff" },
      { id: "swa", title: "Swansea" },
    ],
    "Northern Ireland": [
      { id: "bfs", title: "Belfast" },
      { id: "ldd", title: "Londonderry" },
    ],
  },

  "United States": {
    California: [
      { id: "la", title: "Los Angeles" },
      { id: "sd", title: "San Diego" },
      { id: "sf", title: "San Francisco" },
    ],
    Texas: [
      { id: "hou", title: "Houston" },
      { id: "dal", title: "Dallas" },
      { id: "aus", title: "Austin" },
    ],
    NewYork: [
      { id: "nyc", title: "New York City" },
      { id: "buf", title: "Buffalo" },
    ],
    Illinois: [
      { id: "chi", title: "Chicago" },
      { id: "spi", title: "Springfield" },
    ],
    Florida: [
      { id: "mia", title: "Miami" },
      { id: "orl", title: "Orlando" },
    ],
  },

  "Sri Lanka": {
    "Western Province": [
      { id: "cmb", title: "Colombo" },
      { id: "nbo", title: "Negombo" },
      { id: "mtl", title: "Moratuwa" },
    ],
    "Central Province": [
      { id: "kdy", title: "Kandy" },
      { id: "mat", title: "Matale" },
    ],
    "Southern Province": [{ id: "gal", title: "Galle" }],
    "Northern Province": [{ id: "jaf", title: "Jaffna" }],
    "Eastern Province": [
      { id: "bco", title: "Batticaloa" },
      { id: "trn", title: "Trincomalee" },
    ],
  },

  Nepal: {
    "Bagmati Province": [
      { id: "ktm", title: "Kathmandu" },
      { id: "lal", title: "Lalitpur" },
      { id: "bkt", title: "Bhaktapur" },
    ],
    "Gandaki Province": [{ id: "pok", title: "Pokhara" }],
    "Province No. 1": [
      { id: "bir", title: "Biratnagar" },
      { id: "dhn", title: "Dharan" },
    ],
    "Province No. 2": [
      { id: "brj", title: "Birgunj" },
      { id: "jnp", title: "Janakpur" },
    ],
    "Lumbini Province": [
      { id: "btl", title: "Butwal" },
      { id: "bhr", title: "Bhairahawa" },
    ],
  },
};

export const STATES_BY_COUNTRY: Record<
  string,
  { id: string; title: string }[]
> = {
  India: [
    { id: "mh", title: "Maharashtra" },
    { id: "dl", title: "Delhi" },
    { id: "ka", title: "Karnataka" },
    { id: "tn", title: "Tamil Nadu" },
    { id: "wb", title: "West Bengal" },
    { id: "gj", title: "Gujarat" },
    { id: "rj", title: "Rajasthan" },
    { id: "up", title: "Uttar Pradesh" },
    { id: "pb", title: "Punjab" },
    { id: "kl", title: "Kerala" },
  ],
  Pakistan: [
    { id: "sd", title: "Sindh" },
    { id: "pb", title: "Punjab" },
    { id: "kp", title: "Khyber Pakhtunkhwa" },
    { id: "bl", title: "Balochistan" },
    { id: "is", title: "Islamabad Capital Territory" },
  ],
  Bangladesh: [
    { id: "dh", title: "Dhaka" },
    { id: "ct", title: "Chattogram" },
    { id: "kh", title: "Khulna" },
    { id: "ra", title: "Rajshahi" },
    { id: "sy", title: "Sylhet" },
  ],
  "Sri Lanka": [
    { id: "we", title: "Western Province" },
    { id: "ce", title: "Central Province" },
    { id: "so", title: "Southern Province" },
    { id: "no", title: "Northern Province" },
    { id: "ea", title: "Eastern Province" },
  ],
  Nepal: [
    { id: "ba", title: "Bagmati Province" },
    { id: "ga", title: "Gandaki Province" },
    { id: "lu", title: "Lumbini Province" },
    { id: "pr", title: "Province No. 1" },
    { id: "ko", title: "Koshi Province" },
  ],
  Malaysia: [
    { id: "kl", title: "Kuala Lumpur" },
    { id: "sl", title: "Selangor" },
    { id: "pn", title: "Penang" },
    { id: "jb", title: "Johor" },
    { id: "pr", title: "Perak" },
  ],
  Singapore: [
    { id: "sg", title: "Central Region" }, // Singapore is a city-state, so just regions
    { id: "ne", title: "North-East Region" },
    { id: "nw", title: "North-West Region" },
    { id: "se", title: "South-East Region" },
    { id: "sw", title: "South-West Region" },
  ],
  Thailand: [
    { id: "bk", title: "Bangkok" },
    { id: "cn", title: "Chiang Mai" },
    { id: "pt", title: "Pattaya" },
    { id: "np", title: "Nakhon Pathom" },
    { id: "sl", title: "Songkhla" },
  ],
  Vietnam: [
    { id: "hn", title: "Hanoi" },
    { id: "hcm", title: "Ho Chi Minh City" },
    { id: "dn", title: "Da Nang" },
    { id: "hp", title: "Hai Phong" },
    { id: "ct", title: "Can Tho" },
  ],
  China: [
    { id: "bj", title: "Beijing" },
    { id: "sh", title: "Shanghai" },
    { id: "gd", title: "Guangdong" },
    { id: "sc", title: "Sichuan" },
    { id: "zj", title: "Zhejiang" },
  ],
  Hungary: [
    { id: "bp", title: "Budapest" },
    { id: "he", title: "Heves" },
    { id: "cs", title: "Csongrád-Csanád" },
    { id: "ba", title: "Baranya" },
    { id: "dj", title: "Debrecen County" },
  ],
  Canada: [
    { id: "on", title: "Ontario" },
    { id: "qc", title: "Quebec" },
    { id: "bc", title: "British Columbia" },
    { id: "ab", title: "Alberta" },
    { id: "mb", title: "Manitoba" },
  ],
  France: [
    { id: "idf", title: "Île-de-France" },
    { id: "na", title: "Nouvelle-Aquitaine" },
    { id: "oc", title: "Occitanie" },
    { id: "pdl", title: "Pays de la Loire" },
    { id: "pac", title: "Provence-Alpes-Côte d'Azur" },
  ],
  Mexico: [
    { id: "cmx", title: "Mexico City" },
    { id: "jal", title: "Jalisco" },
    { id: "nl", title: "Nuevo León" },
    { id: "pue", title: "Puebla" },
    { id: "gua", title: "Guanajuato" },
  ],
  Belarus: [
    { id: "mi", title: "Minsk Region" },
    { id: "ho", title: "Homiel Region" },
    { id: "hr", title: "Hrodna Region" },
    { id: "ma", title: "Mahilyow Region" },
    { id: "vi", title: "Vitsebsk Region" },
  ],
  "South Africa": [
    { id: "gp", title: "Gauteng" },
    { id: "wc", title: "Western Cape" },
    { id: "kz", title: "KwaZulu-Natal" },
    { id: "ec", title: "Eastern Cape" },
    { id: "lp", title: "Limpopo" },
  ],
  "United Kingdom": [
    { id: "eng", title: "England" },
    { id: "sct", title: "Scotland" },
    { id: "wls", title: "Wales" },
    { id: "nir", title: "Northern Ireland" },
  ],
  "United States": [
    { id: "al", title: "Alabama" },
    { id: "ak", title: "Alaska" },
    { id: "az", title: "Arizona" },
    { id: "ar", title: "Arkansas" },
    { id: "ca", title: "California" },
    { id: "co", title: "Colorado" },
    { id: "ct", title: "Connecticut" },
    { id: "de", title: "Delaware" },
    { id: "fl", title: "Florida" },
    { id: "ga", title: "Georgia" },
    { id: "hi", title: "Hawaii" },
    { id: "id", title: "Idaho" },
    { id: "il", title: "Illinois" },
    { id: "in", title: "Indiana" },
    { id: "ia", title: "Iowa" },
    { id: "ks", title: "Kansas" },
    { id: "ky", title: "Kentucky" },
    { id: "la", title: "Louisiana" },
    { id: "me", title: "Maine" },
    { id: "md", title: "Maryland" },
    { id: "ma", title: "Massachusetts" },
    { id: "mi", title: "Michigan" },
    { id: "mn", title: "Minnesota" },
    { id: "ms", title: "Mississippi" },
    { id: "mo", title: "Missouri" },
    { id: "mt", title: "Montana" },
    { id: "ne", title: "Nebraska" },
    { id: "nv", title: "Nevada" },
    { id: "nh", title: "New Hampshire" },
    { id: "nj", title: "New Jersey" },
    { id: "nm", title: "New Mexico" },
    { id: "ny", title: "New York" },
    { id: "nc", title: "North Carolina" },
    { id: "nd", title: "North Dakota" },
    { id: "oh", title: "Ohio" },
    { id: "ok", title: "Oklahoma" },
    { id: "or", title: "Oregon" },
    { id: "pa", title: "Pennsylvania" },
    { id: "ri", title: "Rhode Island" },
    { id: "sc", title: "South Carolina" },
    { id: "sd", title: "South Dakota" },
    { id: "tn", title: "Tennessee" },
    { id: "tx", title: "Texas" },
    { id: "ut", title: "Utah" },
    { id: "vt", title: "Vermont" },
    { id: "va", title: "Virginia" },
    { id: "wa", title: "Washington" },
    { id: "wv", title: "West Virginia" },
    { id: "wi", title: "Wisconsin" },
    { id: "wy", title: "Wyoming" },
  ],
};
